export default __webpack_public_path__ + "static/main-video03-4ca8e32411e9b8b63e149c792d1e0965.jpg";